import axios from 'axios'

export const state = {
  hospitals: null,
}

export const getters = {
  hospitals: (state) => state.hospitals,
  hospitalOptions: (state) =>
    state.hospitals &&
    state.hospitals.map(({ hospital, city }) => ({
      id: hospital,
      label: hospital,
      city,
    })),
}

export const mutations = {
  SET_HOSPITALS(state, hospitals) {
    state.hospitals = hospitals
  },
}

export const actions = {
  fetchAllHospitals({ commit, state, rootState }) {
    return axios.get('/api/hospitals').then((response) => {
      const hospitals = response.data
      commit('SET_HOSPITALS', hospitals)
      return hospitals
    })
  },
}
